import { Grid } from '@mui/material';
import BikeFrontSide from '~/assets/icons/BikeFrontSide';
import BikeFrontalWheel from '~/assets/icons/BikeFrontWheel';
import BikeLeftSide from '~/assets/icons/BikeLeftSide';
import BikeRearWheel from '~/assets/icons/BikeRearWheel';
import BikeRightSide from '~/assets/icons/BikeRightSide';
import FileIcon from '~/assets/icons/File';
import FileImage from '~/assets/icons/FileImage';
import FrontGearShift from '~/assets/icons/FrontGearShift';
import RatchetsGroupIcon from '~/assets/icons/RatchetsGroupIcon';
import RearGearShift from '~/assets/icons/RearGearShift';
import SerialIcon from '~/assets/icons/SerialIcon';
import InputFile from '~/components/InputFile';
import { IFile } from '~/services/modules/contract/types';
import RemoteImageIcon from '../../components/RemoteImageIcon';
import type { FilesError, TypeFile } from '../../hooks/types';

type SuraNotNewProps = {
  onChangeFile: (key: TypeFile, file: IFile) => void;
  errors: FilesError;
  equipamentTypeId: number;
  isEmailMode?: boolean;
  documentUrls?: Record<string, string>;
};

export default function SuraNotNew({
  onChangeFile,
  errors,
  equipamentTypeId,
  isEmailMode = false,
  documentUrls = {}
}: SuraNotNewProps) {
  return (
    <>
      <Grid item xs={12} sm={6} display={'flex'} alignItems={'flex-end'}>
        <InputFile
          error={errors?.invoice}
          label="Nota Fiscal"
          onChangeFile={(file) => onChangeFile('invoice', file)}
          baseIcon={
            isEmailMode && documentUrls.invoice ? (
              <RemoteImageIcon imageUrl={documentUrls.invoice} fallbackIcon={<FileIcon />} />
            ) : (
              <FileIcon />
            )
          }
          alternateIcon={<FileImage />}
        />
      </Grid>
      <Grid item xs={12} sm={6} display={'flex'} alignItems={'flex-end'}>
        <InputFile
          error={errors?.overview}
          label="Número de série"
          baseIcon={
            isEmailMode && documentUrls.serial_number_photo ? (
              <RemoteImageIcon imageUrl={documentUrls.serial_number_photo} fallbackIcon={<SerialIcon />} />
            ) : (
              <SerialIcon />
            )
          }
          alternateIcon={<FileImage />}
          onChangeFile={(file) => onChangeFile('serial_number_photo', file)}
        />
      </Grid>
      <Grid item xs={12} sm={6} display={'flex'} alignItems={'flex-end'}>
        <InputFile
          error={errors?.serial_number_photo}
          label="Visão geral do equipamento (lado direito)"
          onChangeFile={(file) => onChangeFile('right_side_overview', file)}
          baseIcon={
            isEmailMode && documentUrls.right_side_overview ? (
              <RemoteImageIcon imageUrl={documentUrls.right_side_overview} fallbackIcon={<BikeRightSide />} />
            ) : (
              <BikeRightSide />
            )
          }
          alternateIcon={<FileImage />}
        />
      </Grid>
      <Grid item xs={12} sm={6} display={'flex'} alignItems={'flex-end'}>
        <InputFile
          error={errors?.ratchets_group}
          label="Visão geral do equipamento (lado esquerdo)"
          onChangeFile={(file) => onChangeFile('left_side_overview', file)}
          baseIcon={
            isEmailMode && documentUrls.left_side_overview ? (
              <RemoteImageIcon imageUrl={documentUrls.left_side_overview} fallbackIcon={<BikeLeftSide />} />
            ) : (
              <BikeLeftSide />
            )
          }
          alternateIcon={<FileImage />}
        />
      </Grid>
      <Grid item xs={12} sm={6} display={'flex'} alignItems={'flex-end'}>
        <InputFile
          error={errors?.ratchets_group}
          label="Grupo de catracas"
          onChangeFile={(file) => onChangeFile('ratchets_group', file)}
          baseIcon={
            isEmailMode && documentUrls.ratchets_group ? (
              <RemoteImageIcon imageUrl={documentUrls.ratchets_group} fallbackIcon={<RatchetsGroupIcon />} />
            ) : (
              <RatchetsGroupIcon />
            )
          }
          alternateIcon={<FileImage />}
        />
      </Grid>
      <Grid item xs={12} sm={6} display={'flex'} alignItems={'flex-end'}>
        <InputFile
          error={errors?.ratchets_group}
          label="Roda dianteira"
          onChangeFile={(file) => onChangeFile('front_wheel', file)}
          baseIcon={
            isEmailMode && documentUrls.front_wheel ? (
              <RemoteImageIcon imageUrl={documentUrls.front_wheel} fallbackIcon={<BikeFrontalWheel />} />
            ) : (
              <BikeFrontalWheel />
            )
          }
          alternateIcon={<FileImage />}
        />
      </Grid>
      <Grid item xs={12} sm={6} display={'flex'} alignItems={'flex-end'}>
        <InputFile
          error={errors?.ratchets_group}
          label="Roda traseira"
          onChangeFile={(file) => onChangeFile('rear_wheel', file)}
          baseIcon={
            isEmailMode && documentUrls.rear_wheel ? (
              <RemoteImageIcon imageUrl={documentUrls.rear_wheel} fallbackIcon={<BikeRearWheel />} />
            ) : (
              <BikeRearWheel />
            )
          }
          alternateIcon={<FileImage />}
        />
      </Grid>
      <Grid item xs={12} sm={6} display={'flex'} alignItems={'flex-end'}>
        <InputFile
          error={errors?.ratchets_group}
          label="Frontal"
          onChangeFile={(file) => onChangeFile('front', file)}
          baseIcon={
            isEmailMode && documentUrls.front ? (
              <RemoteImageIcon imageUrl={documentUrls.front} fallbackIcon={<BikeFrontSide />} />
            ) : (
              <BikeFrontSide />
            )
          }
          alternateIcon={<FileImage />}
        />
      </Grid>
      {equipamentTypeId !== 4 && (
        <Grid item xs={12} sm={6} display={'flex'} alignItems={'flex-end'}>
          <InputFile
            error={errors?.ratchets_group}
            label="Câmbio dianteiro"
            onChangeFile={(file) => onChangeFile('front_gear_shift', file)}
            baseIcon={
              isEmailMode && documentUrls.front_gear_shift ? (
                <RemoteImageIcon imageUrl={documentUrls.front_gear_shift} fallbackIcon={<FrontGearShift />} />
              ) : (
                <FrontGearShift />
              )
            }
            alternateIcon={<FileImage />}
          />
        </Grid>
      )}
      <Grid item xs={12} sm={6} display={'flex'} alignItems={'flex-end'}>
        <InputFile
          error={errors?.ratchets_group}
          label="Câmbio traseiro"
          onChangeFile={(file) => onChangeFile('rear_gear_shift', file)}
          baseIcon={
            isEmailMode && documentUrls.rear_gear_shift ? (
              <RemoteImageIcon imageUrl={documentUrls.rear_gear_shift} fallbackIcon={<RearGearShift />} />
            ) : (
              <RearGearShift />
            )
          }
          alternateIcon={<FileImage />}
        />
      </Grid>

      <Grid item xs={12} sm={6} display={'flex'} alignItems={'flex-end'}>
        <InputFile
          error={errors?.ratchets_group}
          label="Outra foto (opcional)"
          onChangeFile={(file) => onChangeFile('other', file)}
          baseIcon={
            isEmailMode && documentUrls.other ? (
              <RemoteImageIcon imageUrl={documentUrls.other} fallbackIcon={<FileIcon />} />
            ) : (
              <FileIcon />
            )
          }
          alternateIcon={<FileImage />}
        />
      </Grid>
    </>
  );
}
